<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-billing-sidebar>
  <app-invoice-list-table body [transPartKey]="transPartKey"></app-invoice-list-table>
</app-billing-sidebar>
<!--<app-invoice-list-table body [transPartKey]="transPartKey"></app-invoice-list-table>-->

